// extracted by mini-css-extract-plugin
module.exports = {"button":"HeaderReturn_button_su29h","arrow_top":"HeaderReturn_arrow_top_3TVqO"};